import React, { Component } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import axios from "axios";
import authHeader from "../services/auth-header";
import fileDownload from "js-file-download";
import download_icon from "../image/download-icon.png";
import reseticon from "../image/reset.png";

class DownloadData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imei: [],
      startdate: "",
      enddate: "",
      time: "",
      datadownload: "",
      slicetime: "",
      selectedOption: [],
    };
  }
  Country() {
    return this.props.data1.map((data) => ({
      label: data.properties.imei,
      value: data.properties.imei,
    }));
  }

  handleImei = (selectedOption) => {
    this.setState({ selectedOption });
  };

  handleStartDate = (event) => {
    this.setState({
      startdate: event.target.value,
    });
  };

  handleEnddate = (event) => {
    this.setState({
      enddate: event.target.value,
    });
  };

  handleTime = (event) => {
    this.setState({
      time: event.target.value,
    });
  };

  handleSliceTime = (event) => {
    this.setState({
      slicetime: event.target.value,
    });
  };

  handleDataDownload = (event) => {
    this.setState({
      datadownload: event.target.value,
    });
  };

  resetField = () => {
    this.setState({
      imei: [],
      startdate: "",
      enddate: "",
      time: "",
      datadownload: "",
      slicetime: "",
      selectedOption: [],
    });
  };

  //////////////////////////////DOWNLOAD DATA //////////////////////////////

  handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
        headers: authHeader(),
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "red" : "black",
        width: "226px",
        padding: 20,
      }),
      dropdownButton: () => ({
        width: "212px",
        display: "inline-flex",
        border: "1px solid #ced4da",
        height: "calc(1.5em + .75rem + 2px)",
        borderRadius: ".25rem",
        textAlign: "left",
        color: "#979797",
        backgroundColor: "#fff",
        margin: "10px",
      }),
    };

    const { selectedOption } = this.state;

    return (
      <div className="download-data">
        <h5>Download Data</h5>
        <form className="mx-4">
          <div className="download-data-row">
            <div className="input-label">
              <p className="download-input-label-text">Device ID</p>
              <ReactMultiSelectCheckboxes
                placeholderButtonLabel="Select upto 5 Devices ID"
                styles={customStyles}
                options={this.Country()}
                value={selectedOption}
                onChange={this.handleImei}
                isMulti
              />
            </div>

            <div className="input-label">
              <p className="download-input-label-text">Start Date</p>
              <input
                type="datetime-local"
                className="custom-select-download-input"
                placeholder="YYYYMMDD"
                name="startDate"
                value={this.state.startdate}
                onChange={this.handleStartDate}
              />
            </div>

            <div className="input-label">
              <p className="download-input-label-text">End Date</p>
              <input
                type="datetime-local"
                className="custom-select-download-input"
                placeholder="YYYYMMDD"
                name="endDate"
                value={this.state.enddate}
                onChange={this.handleEnddate}
              />
            </div>

            <div className="input-label">
              <p className="download-input-label-text">Average Time</p>
              <select
                className="custom-select-download-input"
                value={this.state.time}
                onChange={this.handleTime}
              >
                <option value="select">Select</option>
                <option value="mm">Minute</option>
                <option value="hh">Hour</option>
                <option value="dd">Day</option>
              </select>
            </div>
            <div className="input-label">
              <p className="download-input-label-text">Slice Time</p>
              <input
                type="number"
                placeholder="Enter number from 1-60"
                min="0"
                max="60"
                className="custom-select-download-input"
                value={this.state.slicetime}
                onChange={this.handleSliceTime}
              />
            </div>
          </div>
          <div className="download-data-buttons">
            <button
              type="button"
              className="download-data-button"
              style={{ marginRight: "10px" }}
              onClick={() => {
                this.handleDownload(
                  `https://atmos.urbansciences.in/adpl/getDeviceData/imei/${this.state.selectedOption.map(
                    (e) => e.label
                  )}/startdate/${this.state.startdate}/enddate/${this.state.enddate
                  }/ts/${this.state.time}/avg/${this.state.slicetime}`,
                  "Chart_data.csv"
                );
              }}
            >
              <p>
                Download
                <img
                  src={download_icon}
                  alt="download"
                  width="15px"
                  style={{ marginLeft: "10px" }}
                />
              </p>
            </button>
            <button type="button" className="download-data-button">
              <a
                style={{
                  textDecoration: "none",
                }}
                onClick={this.resetField}
              >
                <p>
                  Reset
                  <img
                    src={reseticon}
                    alt="reset"
                    style={{ height: "15px", paddingLeft: "10px" }}
                  />
                </p>
              </a>
            </button>
          </div>
        </form>
      </div>
    );
  }
}
export default DownloadData;